
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "CreateFaq",
  mixins: [validationMixin],
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
    };
  },
  methods: {
    submitMainBanner() {
      const mainBanner = store.state.admin.landing.majorShopping.mainBanner;

      store.dispatch("admin/uploadMajorShoppingMainBanner", {
        image: this.chosenFile,
      });
    },
    submitContent() {
      store.dispatch("admin/submitOfferData");
    },
    uploadMainBannerImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateMainBannerMajorShopping",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },

    deleteFaq(id: string): void {
      store.dispatch("admin/deleteFaq", id);
    },

    deleteOffer(id: string): void {
      store.dispatch("admin/deleteOffer", id);
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    offers() {
      return store.state.admin.landing.offers;
    },

    title: {
      get(): string {
        return store.state.admin.landing.offerData.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateOfferDataTitle", value);
      },
    },

    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    language: {
      get(): string {
        return store.state.admin.landing.offerData.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateOfferDataLanguage", value);
      },
    },
    languageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.language?.$dirty) {
        return errors;
      }
      !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    description: {
      get(): string {
        return store.state.admin.landing.offerData.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateOfferDataDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      store.dispatch("admin/updateProductCategory", id);
    }
  },
  validations: {
    language: {
      required,
    },
    title: {
      required,
    },
    description: {
      required,
    },
  },

  created() {
    store.dispatch("admin/getLandingOffers");
  },
});
